import { render, staticRenderFns } from "./ExtrajudicialRecoveryPage.vue?vue&type=template&id=28155e59"
import script from "./ExtrajudicialRecoveryPage.vue?vue&type=script&lang=js"
export * from "./ExtrajudicialRecoveryPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports